import { Injectable, OnInit } from '@angular/core';

import { Toast } from 'bootstrap';

@Injectable({
  providedIn: 'root',
})
export class ToastService implements OnInit {
  private toastElement: any;
  private onToastHidden = () => {
    document.body.classList.remove('toast-active');
  };

  constructor() {
    setTimeout(() => {
      this.toastElement = document.getElementById('liveToast');
    }, 0);
  }

  ngOnInit(): void {
  }

  showSuccess(message: string) {
    this.toastElement.classList.remove(`text-bg-danger`);
    if (message == 'successful') {
      message = 'Request successful'
    }
    this.showToast('Success', message, 'success');
  }

  showError(message: string) {
    this.toastElement.classList.remove(`text-bg-success`);
    this.showToast("Error", message, 'danger');
  }

  showToast(title: string, message: string, type: string) {
    if (this.toastElement) {
      this.toastElement.removeEventListener('hidden.bs.toast', this.onToastHidden as EventListener);
      this.toastElement.classList.add(`text-bg-${type}`);
      this.toastElement.querySelector('.toast-header strong').innerText = title;
      this.toastElement.querySelector('.toast-body').innerText = message;
      this.toastElement.classList.add(`text-bg-${type}`);
      document.body.classList.add('toast-active');
      this.toastElement.addEventListener('hidden.bs.toast', this.onToastHidden as EventListener, { once: true });
      const toast = new Toast(this.toastElement, {
        autohide: true,
        delay: 3500,
      });
      toast.show();
    }
  }
}
